import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
    selector: 'app-applications',
    templateUrl: './applications.component.html',
    providers: [Title]
})
export class ApplicationsComponent implements OnInit {



    constructor(private title: Title, private router: Router) {
        this.title.setTitle('Dashboard - Applications | Sun Life Find My Shares Portal');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

    }

    ///////////////////////////////////////// SHARED OPTIONS ///////////////////////////////////////////////////
    public legendTrue: boolean = true;
    public legendFalse: boolean = false;
    public chartTypeBar: string = 'bar';
    public chartTypeDoughnut: string = 'doughnut';
    public chartTypePolarArea: string = 'polarArea';
    public chartTypeLine: string = 'line';

    // Holders Matched By Chart    
    public holdersMatchedByOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public holdersMatchedByLabels: string[] = ['SRN/HIN', 'Name & DOB', 'No Match'];
    public holdersMatchedByData: number[] = [3654, 2189, 937];



    // Percentage Lost Holders Applied Chart    
    public lostHoldersAppliedOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public lostHoldersAppliedLabels: string[] = ['Applied', 'Not Applied'];
    public lostHoldersAppliedData: number[] = [6780, 742000];

    // Weekly Application Volumes   
    public weeklyApplicationVolumesOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Number of Applications',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                }
            }],
            xAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Last 14 Days',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        }
    };

    public weeklyApplicationVolumesLabels: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'];
    public weeklyApplicationVolumesData: any[] = [
        { data: [223, 216, 170, 144, 267, 245, 190, 210, 234, 198, 98, 212, 111, 453, 123], label: 'Applications' }
    ];

    // PolarArea
    public applicationsPolarAreaOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        scales: {
            yAxes: [{
                display: false
            }],
            xAxes: [{
                display: false
            }]
        },
        layout: {
            padding: {
                top: 10
            }
        }
    };

    public applicationRegionLabels: string[] = ['NSW', 'VIC', 'Other'];
    public applicationRegionData: number[] = [452, 333, 623];

    public applicationCountryLabels: string[] = ['NZL', 'AUS', 'HK'];
    public applicationCountryData: number[] = [986, 1633, 1123];

    //////////////////////////////////////////// COLOURS ///////////////////////////////////////////////////////
    public solidBackgroundColors = [
        {
            backgroundColor: ['rgba(67,91,115,1)', 'rgba(193,189,170,1)', 'rgba(224,216,174,1)', 'rgba(115,91,93,1)', 'rgba(112,114,112,1)', 'rgba(163,170,163,1)', 'rgba(128,109,141,1)', 'rgba(112,92,126,1)', 'rgba(146,114,166,1)']
        }
    ];

    public transparentBackgroundColors = [
        {
            backgroundColor: ['rgba(104,132,155,0.8)', 'rgba(188,201,210,0.8)', 'rgba(193,189,170,0.8)', 'rgba(224,216,174,0.8)', 'rgba(163,170,163,0.8)']
        }
    ];

    public lineChartColors = [
        {
            backgroundColor: 'rgba(104,132,155,0.1)',
            borderColor: 'rgba(104,132,155,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(104,132,155,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(104,132,155,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(224,216,174,0.1)',
            borderColor: 'rgba(224 ,216,174,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(224,216,174,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(224,216,174,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        }
    ];

    // events
    public chartClicked(e: any): void {
        //console.log(e);
    }
    public chartHovered(e: any): void {
        //console.log(e);
    }

}
